/**
 * TenanciesLayout
 *
 * @return {JSX.Element}
 */
import { Outlet } from 'react-router-dom';
import { useTenancies } from 'state';
import { withInitialization } from 'hoc';
import combineHOCs from 'lib/combineHOCs';

export default combineHOCs(withInitialization(useTenancies))(Outlet);
